module.exports = __webpack_public_path__ + "img/sub_top_img.3ad72a9f.png";